var AddressController, AddressFieldController;

AddressFieldController = require('./address_field_controller');
const ADDRESS_INPUT_SELECTOR = '[data-behavior=address-custom-autocomplete]';

AddressController = (function() {
  function AddressController(container = '') {
    if (container.length > 0) {
      this.container = $(container);
    } else {
      this.container = $('body');
    }
    let addressInputs = this.container.find(ADDRESS_INPUT_SELECTOR);
    addressInputs.each(function() {
      new AddressFieldController($(this));
    });
  }

  return AddressController;
})();

module.exports = AddressController;



// WEBPACK FOOTER //
// ./src/javascripts/legacy/address_controller.js